import zsmLayout from '@/zsm-layout'

const statisticsRouter = {
  path: '/fund',
  component: zsmLayout,
  name: 'fund',
  meta: {
    title: '数据统计',
    icon: 'chart',
    affix: true
  },
  children: [
    {
      path: '/fund',
      component: () => import('@/view/fund/index'),
      name: 'orderStatistics',
      // hidden:true,
      /*   meta: {
         title: '数据统计', icon: 'chart', affix: true,
         childList: [
           { meta: { title: '资金收益' }, title: '资金收益', path: '/statistics/funds' },
           { meta: { title: '订单统计' }, title: '订单统计', path: '/statistics/order' },
           // { meta: { title: '收益提现' }, title: '收益提现', path: '/fund/withdraw' }
           // { meta: { title: '订单统计' }, title: '订单统计', path: '/statistics/order' }
           // { meta: { title: '流量和转换' }, title: '流量和转换', path: '/statistics/flow' },
           // { meta: { title: '兼职小店' }, title: '兼职小店', path: '/statistics/shop' }
         ]
       }, */
      redirect: '/fund/withdraw',
      children: [

        /*   {
          meta: {
            title: '数据统计',
            icon: 'chart',
            affix: true
          },
          path: '/fund/withdraw',
          component: () => import('@/view/fund/withdraw'),
          name: 'orderStatistics'
        // hidden: true
        },*/
        {
          path: '/fund/list',
          component: () => import('@/view/fund/list'),
          name: 'orderStatistics'
        // hidden: true
        },
        {
          path: '/fund/withdrawal-record',
          component: () => import('@/view/fund/withdrawal-record'),
          name: 'orderStatistics'
        // hidden: true
        },
        {
          path: '/fund/account',
          component: () => import('@/view/fund/account'),
          name: 'orderStatistics',
          redirect: '/fund/account/alipay',
          // hidden: true,
          children: [{
            path: '/fund/account/alipay',
            component: () => import('@/view/fund/alipay-account'),
            name: 'orderStatistics',
            hidden: true
          },
          {
            path: '/fund/account/bank',
            component: () => import('@/view/fund/bank-account'),
            name: 'orderStatistics',
            hidden: true
          }
          ]
        },
        {
          hidden: true,
          path: '/fund/freeze',
          component: () => import('@/view/fund/freeze')
        },

        {
          hidden: true,
          path: '/fund/freezereason',
          component: () => import('@/view/fund/freezereason')
        }
      ]
    },
    {
      hidden: true,
      path: '/fund/withdraw',
      component: () => import('@/view/fund/withdraw2')
    },
    {
      hidden: true,
      path: '/fund/deposit',
      component: () => import('@/view/fund/deposit')
    },


  ]
}

export default statisticsRouter
